<template>
  <div class="score-table-p">
    <ul>
      <li v-for="(item,index) of value" :key="index" class="score-item-p">
        <div class="flex-left-p">
          <span>{{item.option}}</span>
        </div>
        <div class="process-p">
          <div :style="{width:item.score/item.totalScore*processWidth+'px'}"></div>
        </div>
        <div class="flex-right-p">
          <span>{{item.score}}分（满分{{item.totalScore}}分）</span>
        </div>
      </li>
    </ul>
    <div class="evaluate-p">
      <span>检验评定：</span>
      <span
        :style="assess!=1?{color:'#46da98'}:{color:'#fe2c2c'}"
      >{{assess==1?"不合格":assess==2?"合格":"优良"}}（{{sum}}分）</span>
    </div>
  </div>
</template>

<script>
import "../../../../../html/components/createQE/scoreTable.scss"

export default {
  name: 'scoreTable',
  data() {
    return {
      assess: 3,
      sum: 0,
    }
  },
  methods: {
    show(){
      var totalSum = this.value.length == 7 || this.value.length == 4 ? 100 : 200;
      var assess;
      this.sum = this.value.reduce((total, item) => {
        return total + Number(item.score);
      }, 0);
      if (this.sum >= totalSum * 0.8) {
        assess = 3;
      }
      else if (this.sum >= totalSum * 0.6) {
        assess = 2;
      }
      else {
        assess = 1;
      }
      this.assess = assess;
    }
  },
  computed: {
    totalScore() {
      return this.value.reduce((total, item) => {
        return total + Number(item.score);
      }, 0)
    }
  },
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    processWidth:{
      type:Number,
      default:520
    }
  },
  updated(){
    this.show();
  }

}
</script>
